import { render, staticRenderFns } from "./ContactingBoxNotes.vue?vue&type=template&id=13c4b251&scoped=true&"
import script from "./ContactingBoxNotes.vue?vue&type=script&lang=js&"
export * from "./ContactingBoxNotes.vue?vue&type=script&lang=js&"
import style0 from "./ContactingBoxNotes.vue?vue&type=style&index=0&id=13c4b251&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c4b251",
  null
  
)

export default component.exports